import { render, staticRenderFns } from "./Conteudo.vue?vue&type=template&id=30551556&scoped=true&"
import script from "./Conteudo.vue?vue&type=script&lang=js&"
export * from "./Conteudo.vue?vue&type=script&lang=js&"
import style0 from "./Conteudo.vue?vue&type=style&index=0&id=30551556&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30551556",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})
